import React from 'react';
import { Fade } from '@material-ui/core';
import Loading from '../Loading';
import { useStyles } from './Transition.styles';
import FadeElement from "../FadeElement";

const Transition: React.FC<{
  isLoading: boolean;
  hideSpinner?: boolean;
  children?: React.ReactNode;
}> = ({ isLoading, hideSpinner, children }) => {
  const classes = useStyles();
  return (
    <>
      {!hideSpinner && (
        <div className={classes.loadingContainer}>
          <Fade in={isLoading} unmountOnExit>
            <FadeElement>
              <Loading />
            </FadeElement>
          </Fade>
        </div>
      )}

      <Fade in={!isLoading}>
        <FadeElement>{children}</FadeElement>
      </Fade>
    </>
  );
};

export default Transition;
